import request from '@/utils/request'
let OrderApi = {
  /*订单列表*/
  orderlist(data, errorback) {
    return request._post('/supplier/order.service_order/index', data, errorback);
  },
  /*订单详情*/
  orderdetail(data, errorback) {
    return request._post('/supplier/order.service_order/detail', data, errorback);
  },
  /*完成订单*/
  orderComplete(data, errorback) {
    return request._upload('/supplier/order.service_order/complete', data, errorback);
  },
  /*订单未到店*/
  notcomeClick(data, errorback) {
    return request._upload('/supplier/order.service_order/not_come', data, errorback);
  },
  /*售后管理*/
  orderrefund(data, errorback) {
    return request._post('/supplier/order.service_refund/index', data, errorback);
  },
  /*去发货*/
  delivery(data, errorback) {
    return request._post('/supplier/order.order/delivery', data, errorback);
  },
  /*确认审核*/
  confirm(data, errorback) {
    return request._post('/supplier/order.Operate/confirmCancel', data, errorback);
  },
  /*售后详情*/
  refundDetail(data, errorback) {
    return request._get('/supplier/order.service_refund/detail', data, errorback);
  },
  /*售后审核*/
  Approval(data, errorback) {
    return request._get('/supplier/order.service_refund/audit', data, errorback);
  },
  /*核销*/
  extract(data, errorback) {
    return request._post('/supplier/order.operate/extract', data, errorback);
  },
  /*修改价格*/
  updatePrice(data, errorback) {
    return request._post('/supplier/order.order/updatePrice', data, errorback);
  },
  /*分销订单*/
  agentOrder(data, errorback) {
    return request._post('/supplier/order.agent/index', data, errorback);
  },
  queryLogistics(data, errorback) {
    return request._post('/supplier/order.order/express', data, errorback);
  },
  updateAddress(data, errorback) {
    return request._post('/supplier/order.order/updateAddress', data, errorback);
  },
  /*批量发货*/
  batchDelivery(formData, errorback) {
    return request._upload('/supplier/order.operate/batchDelivery', formData, errorback);
  },
  /*取消订单*/
  orderCancel(formData, errorback) {
    return request._upload('/supplier/order.order/orderCancel', formData, errorback);
  },
  /*虚拟商品发货*/
  virtual(formData, errorback) {
    return request._upload('/supplier/order.order/virtual', formData, errorback);
  },
}

export default OrderApi;



// WEBPACK FOOTER //
// ./src/api/order.js